<!-- eslint-disable max-len -->
<!--eslint-disable-next-line max-len-->
<template>
  <div id="sys_side">
    <div id="sys_side_panel" class="panel-group mt-2" style="min-height: calc(100vh - 100px)">
      <div class="text-center">
        <h3 style="color: #75819a">System</h3>
      </div>
      <!-- <pre>{{ MainMenu }}</pre> -->
      <!------------------------------------------>
      <div v-for="(item, index) in MainMenu" :id="item.code" :key="index">
        <router-link
          v-if="item.subitems.length <= 0 && item.visiable"
          :id="item.code + '_routerLink'"
          :to="item.route"
          class="nochild panel-title ripple"
          aria-expanded="false"
        >
          <el-icon>
            <component :is="item.icon" />
          </el-icon>
          <span>{{ i18n.$t('SysMenu')[item.code] }}</span>
        </router-link>
        <a
          v-if="item.subitems.length > 0"
          role="button"
          :id="item.code + '_title'"
          :data-bs-target="'#' + item.code + '_list'"
          data-bs-toggle="collapse"
          class="haschild panel-title ripple collapsed"
          aria-expanded="false"
          ><el-icon>
            <component :is="item.icon" /> </el-icon
          >{{ i18n.$t('SysMenu')[item.code] }}<i class="fas fa-chevron-circle-left"></i
        ></a>
        <div :id="item.code + '_list'" class="collapse">
          <ul class="list-group">
            <li
              v-for="(child, index) in item.subitems"
              :id="child.code"
              class="list-group-item ripple"
              :key="index"
            >
              <router-link v-if="child.visiable" :to="child.route"
                ><el-icon>
                  <component :is="child.icon" /> </el-icon
                >{{ i18n.$t('SysMenu')[child.code] }}</router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <!------------------------------------------>
    </div>
  </div>
</template>
<script>
import { useI18n } from '@/js/i18n';
import { store } from '@/store';

export default {
  name: 'sideMenu',
  components: {},
  setup() {
    const i18n = useI18n();
    const setLang = (value) => {
      store.commit('setLang', value);
      sessionStorage.setItem('userLang', value);
      i18n.locale.value = value;
    };
    return { i18n, setLang };
  },
  data() {
    return {
      // https://blog.csdn.net/qq_41443611/article/details/122188163
      // code: "B_1",
      // component: "views/Data",
      // name: "匯入資料",
      // route: "/Data",
      // seq: 2,
      // system: false,
      // module_id: "00000000-0000-0000-0000-000000000001",
      // module_name: "Data-Ops",
      // uuid: "00000000-0000-0000-0000-000000000002",
      // visiable: true,
      MainMenu: [],
      MainMenu2: [
        {
          title: '設定',
          code: 'As_0',
          path: null,
          icon: 'Setting',
          subitem: [
            {
              title: '製程',
              code: 'As_1',
              path: '/system/As_1',
              component: '',
              subitem: null,
              icon: 'Setting',
            },
            {
              title: '層別設定',
              code: 'As_2',
              path: '/system/As_2',
              component: '',
              subitem: null,
              icon: 'Setting',
            },
            {
              title: '廠區',
              code: 'As_3',
              path: '/system/As_3',
              component: '',
              subitem: null,
              icon: 'Setting',
            },
          ],
        },
        {
          title: '使用者設定',
          code: 'Bs_0',
          path: null,
          icon: 'Setting',
          subitem: [
            {
              title: '基礎權限設定',
              code: 'Bs_1',
              path: '/system/Bs_1',
              component: '',
              subitem: null,
              icon: 'Setting',
            },
            {
              title: '廠區使用者設定',
              code: 'Bs_2',
              path: '/system/Bs_2',
              component: '',
              subitem: null,
              icon: 'Setting',
            },
            {
              title: '帳號管理 （local/AD）',
              code: 'Bs_3',
              path: '/system/Bs_3',
              component: '',
              subitem: null,
              icon: 'Setting',
            },
          ],
        },
        {
          title: 'Cs_0',
          code: 'Cs_0',
          path: null,
          icon: 'Setting',
          subitem: [
            {
              title: 'Mobile API',
              code: 'Cs_1',
              path: '/system/Cs_1',
              component: '',
              subitem: null,
              icon: 'Setting',
            },
            {
              title: 'Mail （SMTP）',
              code: 'Cs_2',
              path: '/system/Cs_2',
              component: '',
              subitem: null,
              icon: 'Setting',
            },
          ],
        },
      ],
      hasDataOps: false,
    };
  },
  methods: {},
  mounted() {
    const vm = this;
    const GloableMenu = JSON.parse(sessionStorage.getItem('MainMenu') || '[]');
    vm.MainMenu = GloableMenu.filter((item) => {
      return item.system === true;
    });
    vm.MainMenu.forEach((item) => {
      item.subitems.sort((a, b) => {
        return a.seq > b.seq ? 1 : -1;
      });
    });
    //   this.hasDataOps = utils.loopMenu(GloableMenu, 'Data-Ops');
  },
};
</script>
<style scoped>
/* #adc_defect_manage_title {
  display: none !important;
} */

#sys_side {
  background: #fff;
  overflow: auto;
  /*max-height: 841px;*/
  /* min-height: 100%; */
  /* padding-top: 5%; */
}

#sys_side #sys_side_panel {
  overflow-x: hidden;
  overflow-y: scroll;
  /*max-height: 600px;*/
  /* padding: 0px 5px 0px 5px; */
  padding-left: 8px;
  height: 80vh;
  /* background: #000;
  color: #fff; */
}

#sys_side #sys_side_panel::-webkit-scrollbar {
  display: block;
  width: 10px;
}

#sys_side #sys_side_panel::-webkit-scrollbar-track {
  background: transparent;
}

#sys_side #sys_side_panel::-webkit-scrollbar-thumb {
  background: #75818b;
  border-radius: 10px;
}

#sys_side #sys_side_panel::-webkit-scrollbar-thumb:hover {
  background: #9ba7b1;
}

#sys_side_panel a.panel-title,
#sys_side_panel ul li a {
  display: block;
  font-size: 1rem;
}

#sys_side_panel a.panel-title {
  color: #75818b;
  position: relative;
  border-bottom: 1px dashed #ececec;
  /* height: 56px; */
  line-height: 56px;
  padding: 0rem 0.6rem;
}

#sys_side_panel ul li a,
#sys_side_panel ul li a.panel-title {
  /* padding: 0rem 1.6rem 0rem 3.6rem; */
  /* padding: 0rem 1rem 0rem 2.8rem; */
  padding: 0rem 1rem 0rem 3.8rem;
}

#sys_side_panel ul.list-third li a {
  padding: 0rem 1rem 0rem 5rem;
}

#sys_side_panel ul li a.haschild.panel-title {
  border-bottom: none;
}

#sys_side_panel ul {
  padding-left: 0;
}

#sys_side_panel ul li {
  cursor: pointer;
  text-align: left;
  padding: 0;
  border: none;
  /* height: 56px; */
  line-height: 56px;
}

#sys_side_panel ul li a,
#sys_side_panel ul li a.panel-title {
  /* background-color: #ecf5ff; */
  /* ----- */
  /* background-color: #68a9d6;
  color: #fff; */
  background-color: #fff;
  color: #99a3ac;
  border-bottom: 1px solid #eee;
}

#sys_side_panel .panel-title.router-link-active,
#sys_side_panel ul li a.router-link-active {
  color: #438fc3;
  text-shadow: none;
  background: #eee;
  font-weight: bold;
}

/* Ripple effect */

.ripple {
  background-position: center;
  transition: background 0.8s;
}

.ripple:hover {
  background: #92c6e0 radial-gradient(circle, transparent 1%, #92c6e0 1%) center/15000%;
}

.ripple:active {
  background-color: #fff;
  background-size: 100%;
  transition: background 0s;
}

#sys_side_panel a:hover,
#sys_side_panel ul li a.haschild.panel-title:hover {
  /* color: #fff;
  text-shadow: 0px 0px 5px #000;
  background: #438fc3; */
  color: #505f6b;
  /* border-left: 5px solid #438fc3; */
  text-shadow: none;
  background: #eee;
}

#sys_side_panel .panel-title i.fa-chevron-circle-left {
  position: absolute;
  /* right: 7%; */
  right: 7%;
  top: 34%;
}

#sys_side_panel i.el-icon {
  width: 25px;
  height: 20px;
  padding-right: 8px;
  font-size: 1.1rem;
  vertical-align: text-bottom;
}

/*未下拉時的icon*/
a.collapsed i.fa-chevron-circle-left:before {
  content: '\f13a';
}

/* 無子項選中頁面；屬於子項選中頁面 */
/* #sys_side_panel .panel-title.router-path-active,
#sys_side_panel ul li a.router-path-active {
  color: #438fc3;
  text-shadow: none;
  background: #eee;
  font-weight: bold;
} */

/* 最外層有子項且開著項目 */
#sys_side_panel a.haschild.panel-title:not(.collapsed) {
  color: #75818b;
  border-left: 5px solid #75818b;
  font-weight: bold;
}

#sys_side_panel a.haschild.panel-title:not(.collapsed):hover {
  /* color: #fff; */
  color: #75818b;
}

/* 內層有子項且開著項目 */
#sys_side_panel ul li a.haschild.panel-title:not(.collapsed) {
  /* color: #fff;
  background: #4a7c9f; */
  color: #75818b;
  background: #ffffff;
  font-weight: bold;
  border-left: 5px solid #75818b;
}
</style>
